const settings = {
  BACKEND_URL: 'https://api-lms.analytixlabs.co.in',
  FRONTEND_API_URL: 'https://api.analytixlabs.co.in',
  FRONTEND_URL: 'https://www.analytixlabs.co.in/',
  DOMAIN: {domain: '.analytixlabs.co.in'},
}

export default settings
